module.exports = __webpack_public_path__ + "public/img/gantt-task1.b8533323.svg";